import { createFileRoute } from '@tanstack/react-router'
import { AgaveEndpointMatrix } from '../components/agave-endpoint-matrix/AgaveEndpointMatrix'

export const Route = createFileRoute('/_a/agaveEndpoints')({
  component: AgaveEndpointMatrix,
})
